export function Nett() {
  return (
    <a className="w-full p-1 flex justify-center items-center nett" href="https://nett.dev">
      <p className="text-white">Made with</p>
      <img className="h-3 mx-2" src="/heart.svg" alt="Nett Dev" />
      <p className="text-white mr-2">by</p>
      <img className="h-3" src="/nett.svg" alt="Nett Dev" />
    </a>
  )
}